import React, { Component } from "react";
import gif from "../../../assets/images/seo-gif.gif";
import "../../../styles/pages/seo/SEOSocial.css";

export default class SEOSocial extends Component {
  render() {
    return (
      <div className="SEOSocial gutters">
        <div className="g-title mobile on-scroll-anim">SOCIAL MEDIA</div>

        <div className="image-container on-scroll-anim">
          <img src={gif} alt="Make it rain!" />
        </div>

        <div className="text-container">
          <div className="g-title desktop on-scroll-anim">
            SOCIAL MEDIA MANAGEMENT
          </div>
          <div className="g-sub-text on-scroll-anim">
            Nowadays your overall online presence is a key factor in determining
            your websites performance.
            <br />
            <br />
            We can help increase your awareness on social media platforms, using
            engaging content and advertisements.
          </div>
        </div>
      </div>
    );
  }
}
